import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const cardStyle = css({
  width: "100%",
  maxWidth: 444,
  boxShadow: "none",
  borderRadius: 0,
  cursor: "pointer",
  height: "100%",
});

export const linkStyle = css({
  marginTop: 16,
  display: "inline-block",
  fontWeight: 500,
  position: "relative",
  color: "inherit",
  textDecoration: "none",
  "&::after": {
    content: '""',
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "2px",
    backgroundColor: theme.palette.primary.dark,
    transform: "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s ease",
  },
  "&:hover::after": {
    transform: "scaleX(1)",
  },
  "&:hover": {
    textDecoration: "none",
    color: theme.palette.primary.dark,
  },
});

export const contentStyle = css({
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const mediaWrapperStyle = css({
  position: "relative",
  width: "100%",
  height: 200,
  img: {
    objectFit: "cover",
  },
});
